export const TWITTER = 'TWITTER';
export const STORE = 'STORE';
export const BANDCAMP = 'BANDCAMP';
export const FREE_SOUND = 'FREE_SOUND';
export const WEBSITE = 'WEBSITE';

export const LINK_TYPES = [
    {value: TWITTER, label: 'Twitter'},
    {value: STORE, label: 'Store'},
    {value: WEBSITE, label: 'Website'},
    {value: BANDCAMP, label: 'Bandcamp'},
    {value: FREE_SOUND, label: 'Freesound.org'},
];
    
